module.exports = __webpack_public_path__ + "img/estrella-comentario.552c18f3.svg";